import { useEffect, useState } from "react";
import { AuthUser, getCurrentUser } from "aws-amplify/auth";

const useAuthenticatedUser = (): {
  userObj: AuthUser | null;
  loading: boolean;
} => {
  const [userObj, setUserObj] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await getCurrentUser();
        setUserObj(user);
        setLoading(false);
      } catch (error) {
        setUserObj(null);
      }
    };
    fetchUser();
  }, []);

  return { userObj, loading };
};
export default useAuthenticatedUser;
